import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

const SOON_ENGINES = ['Claude'];

const EnginePill = ({ className = '' }) => {
  return (
    <TooltipProvider>
      <div className={`inline-flex items-center gap-1 rounded-full border bg-muted/40 p-1 text-xs font-medium flex-wrap ${className}`}>
        <span
          className="inline-flex items-center gap-1.5 rounded-full bg-primary px-3 py-1 text-primary-foreground"
          aria-current="true"
        >
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" aria-hidden="true" />
          OpenAI API
        </span>
        {SOON_ENGINES.map((engine) => (
          <Tooltip key={engine}>
            <TooltipTrigger asChild>
              <span
                className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-muted-foreground cursor-help"
                aria-disabled="true"
              >
                {engine}
                <span className="rounded bg-secondary px-1.5 py-0.5 text-[10px] uppercase tracking-wider text-secondary-foreground">
                  Planned
                </span>
              </span>
            </TooltipTrigger>
            <TooltipContent className="max-w-xs">
              <p>{engine} tracking is on the backlog. Current results measure the OpenAI API, not consumer chatbot traffic.</p>
            </TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  );
};

export default EnginePill;
